import { render, staticRenderFns } from "./DeliveryReceiptCreate.vue?vue&type=template&id=831b4f50&"
import script from "./DeliveryReceiptCreate.vue?vue&type=script&lang=js&"
export * from "./DeliveryReceiptCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports